import { render } from "./Add_Leave_Request_Modal.vue?vue&type=template&id=6b10d620"
import script from "./Add_Leave_Request_Modal.vue?vue&type=script&lang=js"
export * from "./Add_Leave_Request_Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__